import { init as initRelay } from "../init-relay";
import { ConfluenceTemplateCollectionDetailsRelayPage } from "../pages/software/confluence/templates/collections/confluence-template-collection-details-relay-page";
import {
    ConfluenceTemplateCollectionDetailsRelayPageQuery,
    getConfluenceTemplateCollectionDetailsRelayPageQueryVars
} from "../templates/software/confluence/templates/confluence-templates-page/src/relay/confluence-template-collection-details-relay-page.template";

initRelay(
    ConfluenceTemplateCollectionDetailsRelayPage,
    ConfluenceTemplateCollectionDetailsRelayPageQuery,
    getConfluenceTemplateCollectionDetailsRelayPageQueryVars(window.location)
);
